import _ from 'lodash'
import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { AddScheduleButton } from '../components/AddScheduleButton'
import { AddScheduleDialog } from '../components/AddScheduleDialog'
import { useCreateScheduleMutation } from '@/core/services/schedule'
import { getApiErrorMessage } from '@/utils/errors'
import { useGetSpecialityOptionsQuery } from '@/core/services/speciality-option'

type AddScheduleDialogContainerProps = {
  targetUserId?: string
}

export default function AddScheduleDialogContainer({ targetUserId }: AddScheduleDialogContainerProps) {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const { specialityOptions } = useGetSpecialityOptionsQuery(
    {},
    {
      selectFromResult: ({ data }) => ({ specialityOptions: data?.map((option) => ({ label: option.name, value: option._id })) ?? [] }),
    }
  )
  const [createSchedule, { isLoading: isCreatingSchedule }] = useCreateScheduleMutation()

  const [openDialog, setOpenDialog] = useState(false)

  return (
    <>
      <AddScheduleButton onClick={() => setOpenDialog(true)} />
      <AddScheduleDialog
        isSubmitting={isCreatingSchedule}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        onSubmit={async (data) => {
          try {
            const { isRecurring, recurrenceRule, ...rest } = data
            await createSchedule(_.merge({}, rest, { recurrenceRule: isRecurring ? recurrenceRule : undefined, createdBy: targetUserId })).unwrap()
            setOpenDialog(false)
          } catch (error) {
            enqueueSnackbar(getApiErrorMessage(error, t('notification.schedule.create.error')), { variant: 'error' })
          }
        }}
        specialityOptions={specialityOptions}
      />
    </>
  )
}
